import TabsCategories from './TabsCategories';

export default TabsCategories;
